import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from './logonew.png';
import { useAuth } from './AuthContext';

const Navbar = () => {
  const { user, canView, isSuperAdmin, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light" style={{ backgroundColor: 'black' }}>
      <div className="container-fluid">
        {/* Logo on the extreme left */}
        <NavLink to="/" className="navbar-brand" style={{ marginLeft: '0' }}>
          <img 
            src={logo} 
            alt="Logo" 
            style={{ height: '50px', width: 'auto', marginRight: '20px' }} 
          />
        </NavLink>

        {/* Navbar Toggler - make the icon white */}
        <button 
          className="navbar-toggler" 
          type="button" 
          data-bs-toggle="collapse" 
          data-bs-target="#navbarNav" 
          aria-controls="navbarNav" 
          aria-expanded="false" 
          aria-label="Toggle navigation"
          style={{ borderColor: 'white' }}
        >
          <span 
            className="navbar-toggler-icon" 
            style={{
              backgroundImage: `url("data:image/svg+xml;charset=UTF8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255, 255, 255, 1)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E")`
            }}
          ></span>
        </button>

        {/* Centered navigation tabs */}
        <div className="collapse navbar-collapse justify-content-center" id="navbarNav">
          <ul className="navbar-nav mx-auto">
            {canView('buy') && (
              <li className="nav-item">
                <NavLink 
                  to="/buy" 
                  className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
                  style={({ isActive }) => ({ color: isActive ? '#FFD700' : 'white' })}
                >
                  Buy
                </NavLink>
              </li>
            )}
            {canView('articles') && (
              <li className="nav-item">
                <NavLink
                  to="/articles"
                  className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
                  style={({ isActive }) => ({ color: isActive ? '#FFD700' : 'white' })}
                >
                  Articles
                </NavLink>
              </li>
            )}
            {canView('stock') && (
              <li className="nav-item">
                <NavLink 
                  to="/stock" 
                  className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
                  style={({ isActive }) => ({ color: isActive ? '#FFD700' : 'white' })}
                >
                  Stock
                </NavLink>
              </li>
            )}
            {canView('clients') && (
              <li className="nav-item">
                <NavLink 
                  to="/clients" 
                  className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
                  style={({ isActive }) => ({ color: isActive ? '#FFD700' : 'white' })}
                >
                  Clients
                </NavLink>
              </li>
            )}
            {canView('transactions') && (
              <li className="nav-item">
                <NavLink 
                  to="/transactions" 
                  className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
                  style={({ isActive }) => ({ color: isActive ? '#FFD700' : 'white' })}
                >
                  Transactions
                </NavLink>
              </li>
            )}
            {canView('convert') && (
              <li className="nav-item">
                <NavLink 
                  to="/convert" 
                  className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
                  style={({ isActive }) => ({ color: isActive ? '#FFD700' : 'white' })}
                >
                  Convert
                </NavLink>
              </li>
            )}
            {canView('speed') && (
              <li className="nav-item">
                <NavLink 
                  to="/speed" 
                  className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
                  style={({ isActive }) => ({ color: isActive ? '#FFD700' : 'white' })}
                >
                  Speed
                </NavLink>
              </li>
            )}
           
            {/* Add Dropdown */}
            {canView('add') && (
              <li className="nav-item dropdown">
                <NavLink 
                  className="nav-link dropdown-toggle" 
                  to="#" 
                  id="navbarDropdown" 
                  role="button" 
                  data-bs-toggle="dropdown" 
                  aria-expanded="false"
                  style={{ color: 'white' }}
                >
                  Add
                </NavLink>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li>
                    <NavLink 
                      to="/add-to-pure" 
                      className="dropdown-item"
                      style={({ isActive }) => ({ color: isActive ? '#FFD700' : 'black' })}
                    >
                      Add to Pure
                    </NavLink>
                  </li>
                  <li>
                    <NavLink 
                      to="/add-to-langdi" 
                      className="dropdown-item"
                      style={({ isActive }) => ({ color: isActive ? '#FFD700' : 'black' })}
                    >
                      Add to Langdi
                    </NavLink>
                  </li>
                  <li>
                    <NavLink 
                      to="/add-cash" 
                      className="dropdown-item"
                      style={({ isActive }) => ({ color: isActive ? '#FFD700' : 'black' })}
                    >
                      Add to Cash
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/add-article"
                      className="dropdown-item"
                      style={({ isActive }) => ({ color: isActive ? '#FFD700' : 'black' })}
                    >
                      Add Article
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}
            {/* Sell Dropdown */}
            {canView('sell') && (
              <li className="nav-item dropdown">
                <NavLink 
                  className="nav-link dropdown-toggle" 
                  to="#" 
                  id="navbarDropdownSell" 
                  role="button" 
                  data-bs-toggle="dropdown" 
                  aria-expanded="false"
                  style={{ color: 'white' }}
                >
                  Sell
                </NavLink>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdownSell">
                  <li>
                    <NavLink 
                      to="/sell-pure-weight" 
                      className="dropdown-item"
                      style={({ isActive }) => ({ color: isActive ? '#FFD700' : 'black' })}
                    >
                      Sell Pure Weight
                    </NavLink>
                  </li>
                  <li>
                    <NavLink 
                      to="/sell-langdi-weight" 
                      className="dropdown-item"
                      style={({ isActive }) => ({ color: isActive ? '#FFD700' : 'black' })}
                    >
                      Sell Langdi Weight
                    </NavLink>
                  </li>
                  <li>
                    <NavLink 
                      to="/sell-cash-amount" 
                      className="dropdown-item"
                      style={({ isActive }) => ({ color: isActive ? '#FFD700' : 'black' })}
                    >
                      Sell Cash Amount
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/sell-article"
                      className="dropdown-item"
                      style={({ isActive }) => ({ color: isActive ? '#FFD700' : 'black' })}
                    >
                      Sell Article
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}
            
            {canView('advance') && (
              <li className="nav-item">
                <NavLink 
                  to="/advance" 
                  className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
                  style={({ isActive }) => ({ color: isActive ? '#FFD700' : 'white' })}
                >
                  Advance
                </NavLink>
              </li>
            )}
            {canView('speedThane') && (
              <li className="nav-item">
                <NavLink
                  to="/speed-thane"
                  className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
                  style={({ isActive }) => ({ color: isActive ? '#FFD700' : 'white' })}
                >
                  Speed Thane
                </NavLink>
              </li>
            )}
          </ul>

          {/* Right side: User menu */}
          <ul className="navbar-nav">
            <li className="nav-item dropdown">
              <a 
                className="nav-link dropdown-toggle" 
                href="#" 
                id="userDropdown" 
                role="button" 
                data-bs-toggle="dropdown" 
                aria-expanded="false"
                style={{ color: '#FFD700' }}
              >
                {user?.name || 'User'}
              </a>
              <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
                {isSuperAdmin() && (
                  <li>
                    <NavLink to="/users" className="dropdown-item">
                      User Management
                    </NavLink>
                  </li>
                )}
                <li>
                  <NavLink to="/change-password" className="dropdown-item">
                    Change Password
                  </NavLink>
                </li>
                <li><hr className="dropdown-divider" /></li>
                <li>
                  <button className="dropdown-item text-danger" onClick={handleLogout}>
                    Logout
                  </button>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
